export default __webpack_public_path__ + "static/media/pro1.b5986f03.png";